import { isMobileBreakpoint, mediaQueryLarge } from "@theme/utilities";
class HotspotSection extends HTMLElement {
  constructor() {
    super();
    this.appearanceAnimation = this.hasAttribute("data-appearance-animation");
    this.accordionsContainer = this.querySelector(".hotspots-accordions");
    this.hotspotsContainer = this.querySelector(".js-hotspots-container");

    /** @type {NodeListOf<HTMLElement>} */
    this.hotspots = this.querySelectorAll(".hotspot__wrapper");

    /** @type {NodeListOf<HTMLElement>} */
    this.accordions = this.querySelectorAll("accordion-custom");

    /** @type {NodeListOf<HTMLDetailsElement> | undefined} */
    this.detailsList = this.accordionsContainer?.querySelectorAll("details");

    /** @type {HTMLElement | null} */
    this.background = this.querySelector(".hotspot-section__background");

    this._observer = null;
    this.handleToggle = this.handleToggle.bind(this);
    this.appearanceDelay = Number(this.dataset.appearanceDelay);
    this.isMobile = isMobileBreakpoint();
  }

  reinitAppearanceDesktop() {
    const delay = this.hotspots.length * this.appearanceDelay + 600;
    this.background?.classList.remove("hotspot-section__background--appear");
    this.hotspotsContainer?.classList.remove("hotspots--appear");
    setTimeout(() => {
      this.animateAppearanceHotspots();
    }, delay);
  }

  reinitAppearanceMobile() {
    this.accordionsContainer?.classList.remove("hotspots-accordions--appear");
    const delay = this.accordions.length * this.appearanceDelay;
    setTimeout(() => {
      this.animateAppearanceAccordions();
    }, delay);
  }
  /**
   * @param {MediaQueryListEvent} e
   */
  #onMediaQueryChange(e) {
    e.matches ? this.reinitAppearanceDesktop : this.reinitAppearanceMobile();
  }

  /**
   * @param {Event} e
   */
  handleToggle(e) {
    const toggled = e.target;
    if (!(toggled instanceof HTMLDetailsElement)) return;

    if (toggled.open) {
      this.detailsList?.forEach((other) => {
        if (other !== toggled) {
          other.open = false;
          other.removeAttribute("open");
        }
      });
    }
  }
  initObserver() {
    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isMobile ? this.animateAppearanceAccordions() : this.animateAppearanceHotspots();
            this._observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    this._observer.observe(this);
  }

  animateAppearanceAccordions() {
    if (!this.accordionsContainer) return;
    this.accordionsContainer.classList.add("hotspots-accordions--appear");
    this.accordions.forEach((el, i) => {
      el.style.transitionDelay = `${i * this.appearanceDelay}ms`;
    });
  }

  animateAppearanceHotspots() {
    if (!this.background) {
      this.animateHotspots();
      return;
    }
    this.background.classList.add("hotspot-section__background--appear");
    this.background.addEventListener("transitionend", () => this.animateHotspots(), { once: true });
  }

  animateHotspots() {
    if (!this.hotspotsContainer) return;
    this.hotspotsContainer.classList.add("hotspots--appear");
    this.hotspots.forEach((el, i) => {
      el.style.transitionDelay = `${i * this.appearanceDelay}ms`;
    });
  }

  connectedCallback() {
    if (this.detailsList?.length) {
      this.detailsList.forEach((el) => {
        el.addEventListener("toggle", this.handleToggle);
      });
    }

    if (!this.appearanceAnimation) return;
    mediaQueryLarge.addEventListener("change", this.#onMediaQueryChange.bind(this));
    if ((this.isMobile && !this.accordions.length) || (!this.isMobile && !this.hotspots.length)) return;
    this.initObserver();
  }

  disconnectedCallback() {
    if (this.appearanceAnimation) {
      mediaQueryLarge.removeEventListener("change", this.#onMediaQueryChange.bind(this));
    }
    if (this._observer) {
      this._observer.disconnect();
    }
    if (this.detailsList?.length) {
      this.detailsList.forEach((el) => {
        el.removeEventListener("toggle", this.handleToggle);
      });
    }
  }
}

if (!customElements.get("hotspot-section")) {
  customElements.define("hotspot-section", HotspotSection);
}
